import FaqsContainer from "./container/FaqsContainer";
export default FaqsContainer;
